import { Tabs } from "@mantine/core";
import { useStyle } from "../InventoryOrders.styles";
import PaymentReconciliation from "./Tabs/PaymentReconciliation";

const FundPull = () => {
  const { classes } = useStyle();
  return (
    <div>
      <div>
        <h1 className={classes.headerText}>Fund Pull</h1>
      </div>

      <Tabs defaultValue="payment-reconciliation">
        <Tabs.List>
          <Tabs.Tab value="payment-reconciliation">Payment Reconciliation</Tabs.Tab>
        </Tabs.List>

        <Tabs.Panel value="payment-reconciliation" pt="xs">
          <PaymentReconciliation />
        </Tabs.Panel>
      </Tabs>
    </div>
  );
};

export default FundPull;